import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { GetItemsParams } from '../../attorney/service/attorney.model';
import { Observable } from 'rxjs';
import { Page, ToastType } from 'src/app/enums/enums';
import { ToastService } from 'src/app/services/toast.service';
import { HttpClient } from '@angular/common/http';

export interface WeekDays {
  patientId: number;
  monday: boolean | number;
  mondayNote?: string;
  tuesday: boolean | number;
  tuesdayNote?: string;
  wednesday: boolean | number;
  wednesdayNote?: string;
  thursday: boolean | number;
  thursdayNote?: string;
  friday: boolean | number;
  fridayNote?: string;
  saturday: boolean | number;
  saturdayNote?: string;
  [key: string]: boolean | number | string | null | undefined; // Add this line
}
export interface CaseDetails extends WeekDays {
  id: number;
  patientId: number;
  firstName: string;
  lastName: string;
  address: string;
  town: string;
  zip: string;
  oV_W: string;
  phoneNumber: string;
  dateOfAccident: string; // ISO string format
  dateOfEntry: string; // ISO string format
  caseType: number;
  caseName: string;
  attorneyId: number | null;
  attorneyName: string | null;
  p_U: boolean;
  disabled: boolean;
  note: string;
  totalRecords: number;
}

@Injectable({
  providedIn: 'root'
})
export class PatientChecklistService {
  constructor(private apiService: HttpService, public toastService: ToastService, private http: HttpClient) {}

  GetPatientCheckList(param: GetItemsParams): Observable<any> {
    let params = this.apiService.Params;
    params = params.set('searchDate', param.searchDate || Date());
    params = params.set('clinicId', param.clinicId || 0);
    params = params.set('searchValue', param.searchValue);
    params = params.set('pageNumber', param.pageNumber || 1);
    params = params.set('pageSize', param.pageSize || Page.Size);
    return this.apiService.getData(`Report/PatientCallingSchedule`, params);
  }

  UpdatePatientAttendance(id: number, data: WeekDays): Observable<any> {
    return this.apiService.putData(`Report/PatientCallingSchedule/${id}`, data);
  }

  ExportPatientAttendance(param: GetItemsParams): Observable<any> {
    let params = this.apiService.Params;
    params = params.set('searchDate', param.searchDate || Date());
    params = params.set('clinicId', param.clinicId || 0);
    if (param.searchValue) {
      params = params.set('searchValue', param.searchValue);
    }
    return this.apiService.getBlobData(`Report/ExportPatientCallingSchedule`, params);
  }
}
